module.exports = __webpack_public_path__ + "510-small.png?a92afe41fd35d2de97cc9e84b0385ea3";